module.exports = require('./components/Modal');




//////////////////
// WEBPACK FOOTER
// /var/www/festagent_staging/shared/~/react-modal/lib/index.js
// module id = 206
// module chunks = 0 1